// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  TestCaseBulkActionEditPayload,
  TestCaseBulkActionEditPayloadFromJSON,
  TestCaseBulkActionEditPayloadToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestCaseBulkActionPayload
 */
export interface TestCaseBulkActionPayload {
  /**
   * Bulk actions like automation. `archive` archives the given test cases and `unarchive` restores them (TCV-7033). Both need the right to delete the cases: the test case bulk update permission, or the delete permission (with its \"only mine\" variant, only for cases the caller created).
   * @type {string}
   * @memberof TestCaseBulkActionPayload
   */
  actionType: string;
  /**
   *
   * @type {number}
   * @memberof TestCaseBulkActionPayload
   */
  project: number;
  /**
   *
   * @type {Array<number>}
   * @memberof TestCaseBulkActionPayload
   */
  testcaseIds: Array<number>;
  /**
   * Applicable for automation only - Resume if single test case is selected
   * @type {boolean}
   * @memberof TestCaseBulkActionPayload
   */
  resume?: boolean;
  /**
   * Applicable for automation only - Resume from step number if single test case is selected
   * @type {number}
   * @memberof TestCaseBulkActionPayload
   */
  resumeFrom?: number;
  /**
   *
   * @type {TestCaseBulkActionEditPayload}
   * @memberof TestCaseBulkActionPayload
   */
  editParams?: TestCaseBulkActionEditPayload;
  /**
   * Existing primary and secondary reviewer user IDs for actionType review. Secondary is the author-conflict fallback, not a reviewer group. Mutually exclusive with reviewer_group.
   * @type {Array<number>}
   * @memberof TestCaseBulkActionPayload
   */
  reviewers?: Array<number>;
  /**
   * Active project reviewer group ID for actionType review. Mutually exclusive with reviewers. Requires an eligible non-author member for each case and the existing authority to change assignments of cases already under review.
   * @type {number}
   * @memberof TestCaseBulkActionPayload
   */
  reviewerGroup?: number;
}

export function TestCaseBulkActionPayloadFromJSON(
  json: any
): TestCaseBulkActionPayload {
  return {
    actionType: json["actionType"],
    project: json["project"],
    testcaseIds: json["testcaseIds"],
    resume: !exists(json, "resume") ? undefined : json["resume"],
    resumeFrom: !exists(json, "resumeFrom") ? undefined : json["resumeFrom"],
    editParams: !exists(json, "editParams")
      ? undefined
      : TestCaseBulkActionEditPayloadFromJSON(json["editParams"]),
    reviewers: !exists(json, "reviewers") ? undefined : json["reviewers"],
    reviewerGroup: !exists(json, "reviewer_group")
      ? undefined
      : json["reviewer_group"],
  };
}

export function TestCaseBulkActionPayloadToJSON(
  value?: TestCaseBulkActionPayload
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    actionType: value.actionType,
    project: value.project,
    testcaseIds: value.testcaseIds,
    resume: value.resume,
    resumeFrom: value.resumeFrom,
    editParams: TestCaseBulkActionEditPayloadToJSON(value.editParams),
    reviewers: value.reviewers,
    reviewer_group: value.reviewerGroup,
  };
}
